import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Form, Input, Button } from 'antd';
import {
  SaveOutlined, SafetyCertificateOutlined,
  SettingOutlined, SafetyOutlined, CloseOutlined,
} from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { rolesService } from '../../common/services';
import PermissionsSelector from '../../components/permissionsSelector';
import '../../components/capFormShell.scss';

const AjouterRole = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [selectedPerms, setSelectedPerms] = useState([]);
  const { id } = useParams();
  const editing = !!id;
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      rolesService.getById(id).then((res) => {
        const data = res?.data || res;
        form.setFieldsValue({ name: data.name, description: data.description });
        setSelectedPerms(data.permissions || []);
      }).catch(() => toast.error('Erreur lors du chargement du rôle'));
    }
  }, [id]);

  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      const data = { ...values, permissions: selectedPerms };
      if (editing) { await rolesService.update(id, data); toast.success('Rôle mis à jour avec succès'); }
      else { await rolesService.create(data); toast.success('Rôle créé avec succès'); }
      navigate('/dashboard/roles');
    } catch (error) {
      toast.error(error.message || 'Une erreur est survenue');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="content-wrapper">
      <div className="role-form-page">
        {/* Header */}
        <header className="role-form-header">
          <span className="role-form-header-icon"><SafetyCertificateOutlined /></span>
          <div>
            <h1 className="role-form-title">{editing ? 'Modifier le rôle' : 'Nouveau rôle'}</h1>
            <p className="role-form-subtitle">
              Définissez le nom du rôle et les permissions accordées aux utilisateurs concernés.
            </p>
          </div>
        </header>

        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          {/* Carte Informations */}
          <div className="role-form-card" style={{ marginBottom: 16 }}>
            <div className="role-form-card-head">
              <SettingOutlined />
              <h2 className="role-form-card-title">Informations du rôle</h2>
            </div>
            <div className="role-form-card-body">
              <div className="role-form-fields">
                <Form.Item
                  name="name"
                  label={<span className="role-form-label">Nom du rôle</span>}
                  rules={[{ required: true, message: 'Le nom du rôle est requis' }]}
                >
                  <Input placeholder="Ex. : Agent, Comptable, Superviseur…" allowClear />
                </Form.Item>
                <Form.Item
                  name="description"
                  label={<span className="role-form-label">Description</span>}
                >
                  <Input placeholder="Brève description du périmètre du rôle (facultatif)" allowClear />
                </Form.Item>
              </div>
            </div>
          </div>

          {/* Carte Permissions */}
          <div className="role-form-card">
            <div className="role-form-card-head">
              <SafetyOutlined />
              <h2 className="role-form-card-title">Permissions</h2>
            </div>
            <PermissionsSelector value={selectedPerms} onChange={setSelectedPerms} />
          </div>

          {/* Barre d'action sticky */}
          <div className="role-form-footer">
            <div className="role-form-footer-recap">
              <SafetyCertificateOutlined />
              <span>Permissions sélectionnées</span>
              <span className="role-form-footer-badge">{selectedPerms.length}</span>
            </div>
            <div className="role-form-footer-actions">
              <Button
                icon={<CloseOutlined />}
                className="role-form-btn-cancel"
                onClick={() => navigate('/dashboard/roles')}
              >
                Annuler
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                loading={loading}
                icon={<SaveOutlined />}
                className="role-form-btn-save"
              >
                {loading ? 'Enregistrement…' : editing ? 'Mettre à jour le rôle' : 'Créer le rôle'}
              </Button>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default AjouterRole;
